import { render, staticRenderFns } from "./AdminMessages.vue?vue&type=template&id=05da686c&scoped=true"
import script from "./AdminMessages.vue?vue&type=script&lang=js"
export * from "./AdminMessages.vue?vue&type=script&lang=js"
import style0 from "./AdminMessages.vue?vue&type=style&index=0&id=05da686c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da686c",
  null
  
)

export default component.exports